import React, { useEffect, useState } from 'react';
import LoginIntro from '../components/LoginIntro/LoginIntro';
import { Amplify, Hub, Auth, I18n } from 'aws-amplify';
import { useLocation, useHistory } from 'react-router-dom';
import awsconfig from '../aws-exports';
import { AmplifyAuthenticator, AmplifySignIn, AmplifySignUp, AmplifyForgotPassword, AmplifyConfirmSignUp, AmplifyRequireNewPassword } from '@aws-amplify/ui-react';
// import Cookies from 'js-cookie';
import { cx, css } from '@emotion/css';

Amplify.configure(awsconfig);

I18n.putVocabularies({
  en: {
    'Incorrect username or password.': 'Incorrect username or password.',
  },
});

const authContainer = cx(css`
  opacity: 0;
  visibility: hidden;
  transition: opacity 500ms 100ms, visibility 500ms 100ms;
  // border: 2px solid red;
  // margin-top: 20px;
  position: relative; /* Ensure it's positioned properly */
  // z-index: 1100 !important; /* Navbar (1000) se upar */
  
  &.is-show {
    opacity: 1;
    visibility: visible;
  }
`);



function LoginPage() {
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {

    const checkIfMigratedUser = async (username) => {
      try {
        // Fetch user from DynamoDB to check if they have a migration flag
        const apiUrl = process.env.REACT_APP_API_URL;
        console.log('[DEBUG] Checking migration status for:', username);
        console.log('[DEBUG] API URL:', apiUrl);

        const response = await fetch(`https://api.dev.quizwizard.net/quiz/getuser`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            username: username,
            appname: 'QuizWhiz'
          })
        });

        console.log('[DEBUG] API response status:', response.status);

        if (response.ok) {
          const userData = await response.json();
          console.log('[DEBUG] User data from API:', userData);
          console.log('[DEBUG] is_migrated field value:', userData.is_migrated);

          // Check if user has is_migrated flag set to true
          const isMigrated = userData.is_migrated === true;
          console.log('[DEBUG] Returning isMigrated:', isMigrated);

          return isMigrated;
        }
        console.log('[DEBUG] API response not OK');
        return false;
      } catch (error) {
        console.error('[DEBUG] Error checking user migration status:', error);
        return false;
      }
    };

    const getTokenByEvent = async (data) => {
      switch (data.payload.event) {
        case 'signIn': {
          // Clear the is_migrated flag on successful login
          try {
            const user = await Auth.currentAuthenticatedUser();
            const session = await Auth.currentSession();
            const jwt = session.getAccessToken().getJwtToken();
            const username = user.username;

            const apiUrl = process.env.REACT_APP_API_URL;

            // First, fetch the current user data
            const getUserResponse = await fetch(`https://api.dev.quizwizard.net/quiz/getuser`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': jwt
              },
              body: JSON.stringify({
                username: username,
                appname: 'QuizWhiz'
              })
            });

            if (getUserResponse.ok) {
              const userData = await getUserResponse.json();

              // Only update if user is currently marked as migrated
              if (userData.is_migrated === true) {
                // Update user with is_migrated = false, keeping all other fields
                await fetch(`https://api.dev.quizwizard.net/quiz/updateuser`, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'Authorization': jwt
                  },
                  body: JSON.stringify({
                    ...userData,
                    is_migrated: false
                  })
                });
                console.log('✅ Migration flag cleared for user:', username);
              }
            }
          } catch (error) {
            console.error('Error clearing migration flag:', error);
          }

          if (location.pathname === '/login') {
            history.push('/practiceevents'); // Navigate first
            setTimeout(() => window.location.reload(), 0); // Reload after navigation
          }
          break;
        }
        case 'signIn_failure': {
          const error = data.payload.data;
          const username = data.payload.data?.username;

          if (error && error.code) {
            // Check for specific error codes
            if (error.code === 'PasswordResetRequiredException') {
              // Definitely a migrated user
              setTimeout(() => {
                const errorElement = document.querySelector('[data-amplify-authenticator-error]');
                if (errorElement) {
                  errorElement.textContent = 'Your password has expired. Please reset it.';
                }
              }, 100);
            }
            // For NotAuthorizedException, check if user is migrated
            else if (error.code === 'NotAuthorizedException' && username) {
              console.log('[DEBUG] Login failed with NotAuthorizedException');
              console.log('[DEBUG] Username:', username);

              // Check if this is a migrated user
              checkIfMigratedUser(username).then(isMigrated => {
                console.log('[DEBUG] Is migrated user:', isMigrated);

                if (isMigrated) {
                  console.log('[DEBUG] Migrated user detected - redirecting to Forgot Password');

                  // Store username for forgot password flow
                  sessionStorage.setItem('reset_username', username);

                  // Trigger forgot password flow by finding and clicking the forgot password link
                  setTimeout(() => {
                    const forgotPasswordLink = document.querySelector('amplify-forgot-password');
                    const forgotPasswordButton = document.querySelector('[slot="forgot-password"]');

                    // Try to programmatically switch to forgot password screen
                    // The Amplify UI uses internal state management, so we need to trigger it
                    const authStateLinks = document.querySelectorAll('amplify-sign-in [data-auth-username]');
                    const forgotLink = Array.from(document.querySelectorAll('a, button')).find(
                      el => el.textContent && el.textContent.toLowerCase().includes('forgot')
                    );

                    if (forgotLink) {
                      console.log('[DEBUG] Clicking forgot password link');
                      forgotLink.click();
                    } else {
                      // Fallback: show error message
                      console.log('[DEBUG] Could not find forgot password link, showing error message');
                      const errorElement = document.querySelector('[data-amplify-authenticator-error]');
                      if (errorElement) {
                        errorElement.textContent = 'Your password has expired. Redirecting to reset password...';
                      }
                    }
                  }, 100);
                } else {
                  console.log('[DEBUG] Not a migrated user - keeping default error message');
                }
              }).catch(err => {
                console.error('[DEBUG] Error checking migration status:', err);
              });
            }
          }
          break;
        }
        case 'customChallenge':
        case 'newPasswordRequired': {
          // User has FORCE_CHANGE_PASSWORD status
          const username = data.payload.data?.username || data.payload.data?.user?.username;
          console.log('[DEBUG] FORCE_CHANGE_PASSWORD detected for user:', username);
          // Let Amplify handle this normally - show password change form
          break;
        }
        default:
          break;
      }
    };

    console.log('[DEBUG] Setting up Hub listener for auth events');
    Hub.listen('auth', getTokenByEvent);

    // Return cleanup function
    return () => {
      console.log('[DEBUG] Removing Hub listener');
      Hub.remove('auth', getTokenByEvent);
    };
  }, [location, history]);

  const signInFields = [
    {
      type: 'username',
      label: 'Username',
      placeholder: 'Please enter your username',
      required: true,
    },
    {
      type: 'password',
      label: 'Password',
      placeholder: 'Please enter your Password',
      required: true,
    },
  ];

  const signUpFields = [
    {
      type: 'username',
      label: 'Username',
      placeholder: 'Please enter your Username',
      required: true,
    },
    {
      type: 'email',
      label: 'Email',
      placeholder: 'Please enter your Email',
      required: true,
    },
    {
      type: 'password',
      label: 'Password',
      placeholder: 'Please enter your Password',
      required: true,
    },
  ];

  const resetpassword = [
    {
      type: 'username',
      label: 'Username',
      placeholder: 'Please enter your Username',
      required: true,
    },
  ];

  const [elm, setElm] = useState(null);
  const [showPasswordResetMessage, setShowPasswordResetMessage] = useState(false);
  const [usernameForReset, setUsernameForReset] = useState(sessionStorage.getItem('reset_username') || ''); // New state

  // Detect when require-new-password screen is shown
  useEffect(() => {
    const checkPasswordResetScreen = setInterval(() => {
      const passwordResetForm = document.querySelector('amplify-require-new-password');
      if (passwordResetForm && !showPasswordResetMessage) {
        setShowPasswordResetMessage(true);
        clearInterval(checkPasswordResetScreen);
      }
    }, 500);

    return () => clearInterval(checkPasswordResetScreen);
  }, [showPasswordResetMessage]);

  // Auto-fill username in forgot password form
  useEffect(() => {
    // Keep trying to fill the username for 15 seconds
    const startTime = Date.now();

    const fillForgotPasswordUsername = setInterval(() => {
      // Stop after 15 seconds
      if (Date.now() - startTime > 15000) {
        clearInterval(fillForgotPasswordUsername);
        return;
      }

      const savedUsername = sessionStorage.getItem('reset_username');

      if (savedUsername) {
        const forgotPasswordComponent = document.querySelector('amplify-forgot-password');

        if (forgotPasswordComponent && forgotPasswordComponent.shadowRoot) {
          // Helper to recursively find input
          const findInputDeep = (root) => {
            if (!root) return null;

            // Check direct children
            let input = root.querySelector('input[name="username"]') ||
              root.querySelector('input[type="text"]') ||
              root.querySelector('input[autocomplete="username"]');

            if (input) return input;

            // Check nested shadow roots
            const allElements = root.querySelectorAll('*');
            for (let i = 0; i < allElements.length; i++) {
              if (allElements[i].shadowRoot) {
                input = findInputDeep(allElements[i].shadowRoot);
                if (input) return input;
              }
            }
            return null;
          };

          let usernameInput = findInputDeep(forgotPasswordComponent.shadowRoot);

          if (usernameInput) {
            // Check if input is visible-ish
            const isVisible = usernameInput.offsetParent !== null;
            console.log('[DEBUG] Input found. Visible:', isVisible, 'Current Value:', usernameInput.value);

            // Only fill if empty or different AND visible
            if (isVisible && usernameInput.value !== savedUsername) {
              console.log('[DEBUG] Auto-filling VISIBLE username input:', savedUsername);

              // Use native setter to bypass React/Amplify state tracking
              const nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
              if (nativeInputValueSetter) {
                nativeInputValueSetter.call(usernameInput, savedUsername);
              } else {
                usernameInput.value = savedUsername;
              }

              // Trigger events
              usernameInput.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
              usernameInput.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
              usernameInput.dispatchEvent(new Event('blur', { bubbles: true, composed: true }));
            }
          }
        }
      }
    }, 200);

    return () => clearInterval(fillForgotPasswordUsername);
  }, []);

  // Watch for login errors in the authenticator toast
  useEffect(() => {
    let observer;

    const checkCognitoStatus = async (username, errorSpan) => {
      try {
        console.log('[DEBUG] Login failed - checking if user has FORCE_CHANGE_PASSWORD:', username);

        // Try temp password to check Cognito status
        const user = await Auth.signIn(username, 'TempPassword123!');

        if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
          console.log('[DEBUG] User has FORCE_CHANGE_PASSWORD status - showing custom message');

          // Disconnect observer to prevent Amplify from resetting the message
          if (observer) {
            observer.disconnect();
            console.log('[DEBUG] Disconnected observer to prevent message reset');
          }

          // Show custom message
          errorSpan.textContent = 'Your password has expired. Redirecting...';
          // Make visible again
          if (errorSpan.parentElement) errorSpan.parentElement.style.visibility = 'visible';

          console.log('[DEBUG] errorSpan after update:', errorSpan.textContent);

          // Store username for forgot password flow
          sessionStorage.setItem('reset_username', username);
          setUsernameForReset(username); // Set React state
          console.log('[DEBUG] Stored username in sessionStorage and state for forgot password flow');

          // Don't sign out - let Amplify handle the state transition
          // await Auth.signOut();

          // Auto-redirect after showing message for 3 seconds
          setTimeout(() => {
            console.log('[DEBUG] Auto-redirecting to Forgot Password');

            // Find and click the forgot password link
            const signInComponent = document.querySelector('amplify-sign-in');
            if (signInComponent && signInComponent.shadowRoot) {
              const forgotLink = Array.from(signInComponent.shadowRoot.querySelectorAll('a, button')).find(
                el => el.textContent?.toLowerCase().includes('forgot') ||
                  el.textContent?.toLowerCase().includes('reset')
              );

              if (forgotLink) {
                console.log('[DEBUG] Found and clicking forgot password link');
                forgotLink.click();
              } else {
                console.log('[DEBUG] Could not find forgot password link');
              }
            }
          }, 3000); // Wait 3 seconds so user can read the message
        }
      } catch (err) {
        console.log('[DEBUG] User does not have FORCE_CHANGE_PASSWORD status:', err.code);

        // User doesn't exist or doesn't have FORCE_CHANGE_PASSWORD
        // Restore standard error and visibility
        errorSpan.textContent = 'Incorrect username or password.';
        if (errorSpan.parentElement) errorSpan.parentElement.style.visibility = 'visible';
      }
    };

    const startWatching = () => {
      const authenticator = document.querySelector('amplify-authenticator');
      if (authenticator && authenticator.shadowRoot) {
        const toast = authenticator.shadowRoot.querySelector('amplify-toast');

        if (toast && toast.shadowRoot) {
          console.log('[DEBUG] Setting up toast error watcher');

          observer = new MutationObserver(() => {
            const errorSpan = toast.shadowRoot.querySelector('span');

            if (errorSpan && errorSpan.textContent.includes('Incorrect username or password')) {
              console.log('[DEBUG] Login error detected in toast - hiding immediately');

              // Hide immediately to prevent flashing
              if (errorSpan.parentElement) {
                errorSpan.parentElement.style.visibility = 'hidden';
              }

              // Get username from sign-in component
              const signInComponent = document.querySelector('amplify-sign-in');
              if (signInComponent && signInComponent.shadowRoot) {
                const usernameInput = signInComponent.shadowRoot.querySelector('input[name="username"]');
                if (usernameInput?.value) {
                  checkCognitoStatus(usernameInput.value.trim(), errorSpan)
                    .catch(() => {
                      // Restore original on error
                      errorSpan.textContent = 'Incorrect username or password.';
                      if (errorSpan.parentElement) errorSpan.parentElement.style.visibility = 'visible';
                    });
                }
              }
            }
          });

          observer.observe(toast.shadowRoot, {
            childList: true,
            subtree: true,
            characterData: true
          });
        }
      }
    };

    const interval = setInterval(() => {
      if (!observer) {
        startWatching();
      }
    }, 500);

    return () => {
      clearInterval(interval);
      if (observer) observer.disconnect();
    };
  }, []);

  return (
    <AmplifyAuthenticator
      className={`auth-form-container ${authContainer} ${elm ? 'is-show' : ''}`}
      usernameAlias="username"
    >
      <div slot="sign-in">
        <LoginIntro setElm={setElm}>
          <AmplifySignIn
            headerText="Sign in"
            slot="sign-in"
            usernameAlias="username"
            formFields={signInFields}
            className="auth-form"
          >
            <div slot="federated-buttons"></div>
          </AmplifySignIn>
        </LoginIntro>
      </div>

      <div slot="sign-up">
        <LoginIntro setElm={setElm}>
          <AmplifySignUp
            headerText="Sign Up"
            slot="sign-up"
            usernameAlias="username"
            className="auth-form"
            formFields={signUpFields}
          ></AmplifySignUp>
        </LoginIntro>
      </div>

      <div slot="forgot-password">
        <LoginIntro setElm={setElm}>
          <AmplifyForgotPassword
            className="auth-form"
            slot="forgot-password"
            username={usernameForReset}
          />
        </LoginIntro>
      </div>

      <div slot="confirm-sign-up">
        <LoginIntro setElm={setElm}>
          <AmplifyConfirmSignUp className="auth-form" slot="confirm-sign-up" />
        </LoginIntro>
      </div>

      <div slot="require-new-password">
        <LoginIntro setElm={setElm}>
          {showPasswordResetMessage && (
            <div style={{
              backgroundColor: '#fff3cd',
              border: '1px solid #ffc107',
              borderRadius: '8px',
              padding: '16px 20px',
              marginBottom: '20px',
              color: '#856404',
              fontSize: '14px',
              lineHeight: '1.5'
            }}>
              <strong style={{ display: 'block', marginBottom: '8px', fontSize: '16px' }}>
                Password Reset Required
              </strong>
              Your password has expired. Please reset it.
            </div>
          )}
          <AmplifyRequireNewPassword className="auth-form" slot="require-new-password" />
        </LoginIntro>
      </div>
    </AmplifyAuthenticator>
  );
}

export default LoginPage;
